export default __webpack_public_path__ + "media/amil_195px_80px-01.png";